export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-button-1.0.0',
    name: 'JDSDatepickerButton'
  },
  hierarchy: {
    container: [
      'jds-text',
      {
        'jds-icon-container': ['jds-icon']
      }
    ]
  },
  base: {
    container: {
      disabled: false,
      height: '{d_0}',
      'border-radius': '{d_2}',
      'background-color': '{d_3}',
      'border-width': '{d_4}',
      'border-color': '{d_5}',
      'flex-direction': '{d_6}',
      'justify-content': '{d_7}',
      'align-items': '{d_8}',
      gap: '{d_9}',
      'padding-right': '{d_10}',
      'padding-left': '{d_11}',
      behavior: {
        hover: {
          'border-color': '{d_12}'
        },
        focus: {
          'border-color': '{d_13}',
          'border-width': '{d_14}'
        },
        active: {
          'border-color': '{d_15}',
          'background-color': '{d_16}'
        }
      }
    },
    'jds-text': {
      'font-family': '{text_187}',
      color: '{text_13}',
      'font-size': '{text_186}',
      'line-height': '{text_188}',
      'letter-spacing': '{text_189}',
      'font-weight': '{text_190}',
      'text-decoration': '{text_7}',
      'text-transform': '{text_base_text_text-transform}'
    },
    'jds-icon': {
      size: '{icon_5}',
      color: '{icon_9}',
      value: 'ic_chevron_down',
      hidden: false,
      ic: 'ic_chevron_down'
    },
    'jds-icon-container': {
      'background-color': '{icon_0}',
      'border-radius': '{icon_1}',
      size: '{icon_2}',
      'justify-content': '{icon_3}',
      'align-items': '{icon_4}',
      hidden: false,
      ic: 'ic_chevron_down'
    }
  },
  variant: {
    state: {
      selected: {
        container: {
          'background-color': '{d_17}',
          'border-color': '{d_18}'
        },
        'jds-icon': {
          value: 'ic_chevron_up',
          ic: 'ic_chevron_up'
        },
        'jds-icon-container': {
          ic: 'ic_chevron_up'
        }
      },
      disabled: {
        container: {
          disabled: true,
          'border-width': '{d_19}',
          opacity: '{d_20}'
        }
      },
      text_only: {
        container: {
          disabled: true,
          'border-width': '{d_21}'
        },
        'jds-text': {
          color: '{text_20}'
        },
        'jds-icon': {
          hidden: true
        },
        'jds-icon-container': {
          hidden: true
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      state: {
        values: ['default', 'selected', 'disabled', 'text_only']
      }
    },
    data: {
      'jds-text': {
        value: {
          type: 'string',
          name: 'text'
        }
      }
    },
    events: {
      container: {
        onClick: 'onClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'button'
          },
          'aria-label': {
            name: 'ariaLabel',
            prop: 'text'
          },
          'aria-expanded': {
            name: '_ariaExpanded'
          }
        }
      }
    }
  }
};
